import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Colors, Fonts } from '../../Utils/theme'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    maxWidth: 700,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: '1.5rem'
  },
  input: {
    height: 60,
    fontFamily: Fonts.content,
    fontWeight: 300,
    fontSize: '1.25rem',
    color: Colors.black,
    backgroundColor: Colors.white,
    borderRadius: 5,
    padding: '0 1rem',
    [theme.breakpoints.down('lg')]: {
      height: 50,
      fontSize: '1rem'
    }
  },
  multiline: {
    minHeight: '12rem',
    maxHeight: '12rem',
    fontFamily: Fonts.content,
    fontWeight: 300,
    fontSize: '1.25rem',
    color: Colors.black,
    backgroundColor: Colors.white,
    borderRadius: 5,
    padding: '0 0.5rem',
    [theme.breakpoints.down('lg')]: {
      fontSize: '1rem',
      minHeight: '10rem',
      maxHeight: '10rem'
    }
  },
  label: {
    fontFamily: Fonts.content,
    fontWeight: 400,
    fontSize: '1.25rem',
    color: Colors.label,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      fontSize: '1rem'
    }
  },
  focusedLabel: {
    fontFamily: Fonts.content,
    fontWeight: 400,
    fontSize: '1rem',
    color: Colors.black
  },
  shrunkLabel: {
    fontWeight: 400,
    fontSize: '1rem',
    color: Colors.black
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  fiTab: {
    outline: 'none',
    fontSize: '1.125rem',
    borderTopLeftRadius: 5,
    zIndex: 1,
    backgroundColor: Colors.white,
    marginBottom: -1,
    border: `1px solid ${Colors.lightBorder}`,
    borderBottom: `1px solid ${Colors.lightBorder}`,
    padding: `.5rem 1rem`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  fiTabActive: {
    outline: 'none',
    fontSize: '1.125rem',
    fontWeight: 600,
    borderTopLeftRadius: 5,
    zIndex: 1,
    backgroundColor: Colors.white,
    marginBottom: -1,
    border: `1px solid ${Colors.lightBorder}`,
    borderBottom: `1px solid ${Colors.white}`,
    padding: `.75rem 1rem`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  enTab: {
    outline: 'none',
    fontSize: '1.125rem',
    borderTopRightRadius: 5,
    zIndex: 1,
    backgroundColor: Colors.white,
    marginBottom: -1,
    border: `1px solid ${Colors.lightBorder}`,
    borderLeft: 0,
    borderBottom: `1px solid ${Colors.lightBorder}`,
    padding: `.75rem 1rem`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  enTabActive: {
    outline: 'none',
    fontSize: '1.125rem',
    fontWeight: 600,
    borderTopRightRadius: 5,
    zIndex: 1,
    backgroundColor: Colors.white,
    marginBottom: -1,
    border: `1px solid ${Colors.lightBorder}`,
    borderLeft: 0,
    borderBottom: `1px solid ${Colors.white}`,
    padding: `.75rem 1rem`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  contentContainer: {
    border: `1px solid ${Colors.lightBorder}`,
    padding: `2rem 1rem .5rem`
  },
  redLight: {
    background: Colors.red,
    height: '0.75rem',
    width: '0.75rem',
    borderRadius: '10rem',
    marginLeft: '0.5rem'
  },
  greenLight: {
    background: Colors.green,
    height: '0.75rem',
    width: '0.75rem',
    borderRadius: '10rem',
    marginLeft: '0.5rem'
  },
  yellowLight: {
    background: Colors.yellow,
    height: '0.75rem',
    width: '0.75rem',
    borderRadius: '10rem',
    marginLeft: '0.5rem'
  }
}))

export default function Input(props) {
  const classes = useStyles()
  const { t } = useTranslation()

  const renderStatus = (lang) => {
    const status = lang === 'fi' ? props.statusFi : props.statusEn
    if (status === 'red') {
      return <div className={classes.redLight} />
    } else if (status === 'green') {
      return <div className={classes.greenLight} />
    } else if (status === 'yellow') {
      return <div className={classes.yellowLight} />
    }
    return null
  }

  const renderTabs = () => {
    const fiActive = props.currentLanguage === 'fi'
    const enActive = props.currentLanguage === 'en'

    return (
      <div className={classes.tabsContainer}>
        <button
          className={fiActive ? classes.fiTabActive : classes.fiTab}
          onClick={() => props.setLanguage('fi')}
        >
          {t('in_finnish')}
          {renderStatus('fi')}
        </button>
        <button
          className={enActive ? classes.enTabActive : classes.enTab}
          onClick={() => props.setLanguage('en')}
        >
          {t('in_english')}
          {renderStatus('en')}
        </button>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      {renderTabs()}
      <div className={classes.contentContainer}>
        {props.content}
      </div>
    </div>
  )
}
